export default "__VITE_ASSET__3r9tbo9H__"